import {
  useCallback,
  useEffect,
} from 'react';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';
import {
  getStatus,
} from 'redux-resource';
import {
  useParams,
  useNavigate,
} from 'react-router';

import {
  coreActions,
  coreSelectors,
} from '@gymcloud/core';

import {
  uiActions,
} from 'web-actions';

import {
  getUiState,
} from 'web-selectors';
import {
  usePageView,
} from 'web-hooks';

import {
  Spinner,
  NotFound,
  EventResults,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

const EventResultsPage = () => {
  const params = useParams();
  const id = +params.id!;
  const resourceType = 'workoutEvents';
  const mapState = useCallback(state => ({
    readStatus: getStatus(
      state,
      [
        `${resourceType}.requests.fetchFullEvent.status`,
        `${resourceType}.meta[${id}].readStatus`,
      ],
      true,
    ),
    changeStatus: getStatus(
      state,
      [
        'exerciseResults.requests.createResultItems.status',
        'exerciseResults.requests.removeAllResults.status',
      ],
    ),
    finishStatus: getStatus(
      state,
      ['workoutEvents.requests.finishEvent.status'],
    ),
    event: coreSelectors.getCurrentEvent(resourceType, id)(state),
    settings: coreSelectors.getProfile('user_settings')(state),
    exercises: coreSelectors.getAllEventExercises(id)(state),
    namespace: getUiState('namespace')(state),
  }), [id]);
  const {
    event,
    settings,
    exercises,
    namespace,
    readStatus,
    changeStatus,
    finishStatus,
  } = useSelector(mapState, shallowEqual);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(coreActions.requestLoadFullWorkoutEvent({
      id,
    }));
  }, [id]);

  usePageView({
    eventKey: 'viewed_results',
    attrs: event,
    enabled: readStatus.succeeded,
  });

  const handleFinished = () => {
    if (!settings.tutorial_steps.includes('ideafit_perform_workout')) {
      dispatch(
        coreActions.requestMarkTutotialStepsComplite({
          steps: ['ideafit_perform_workout'],
        }),
      );
    }

    dispatch(
      coreActions.requestFinishEvent(
        event.id,
        {
          onSuccess: () => {
            navigate('/welcome');
          },
        },
      ),
    );
  };

  const handleRemoveAll = () => {
    const onConfirmAction = coreActions.requestRemoveAllEventResults(
      event.id,
    );

    dispatch(
      uiActions.confirmModal({
        modal: {
          title: 'Remove All results?',
          bodyText: 'Are you sure you want remove all results?',
        },
        onConfirmAction,
      }),
    );
  };

  return (
    <Flex fillSpace>
      {readStatus.succeeded && (
        <EventResults
          event={event}
          exercises={exercises}
          namespace={namespace}
          onFinished={handleFinished}
          onRemoveAll={handleRemoveAll}
        />
      )}

      {(changeStatus.pending || finishStatus.pending) && (
        <Spinner over message="Plase wait..." />
      )}

      {readStatus.pending && (
        <Spinner message="Loading Event..." />
      )}

      {readStatus.failed && (
        <NotFound title={`Event Not Found (${id})`} />
      )}
    </Flex>
  );
};

export default EventResultsPage;
